import { combineReducers } from 'redux'
import $$byId from 'common/notifications/reducers/byId'
import $$allIds from 'common/notifications/reducers/allIds'

export default combineReducers({
  $$byId,
  $$allIds,
})
